<template>
  <v-app-bar
    id="core-toolbar"
    app
    flat
    prominent
    height="70"
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon>
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />

    <router-link v-ripple class="toolbar-items" to="/">
      <v-icon color="tertiary">mdi-view-dashboard</v-icon>
    </router-link>
    <router-link v-ripple class="toolbar-items" to="/user-profile">
      <v-icon color="tertiary">mdi-account</v-icon>
    </router-link>
  </v-app-bar>
</template>

<script>
export default {
  name: "app-header",
  data: () => ({
    notifications: [
      "Mike, John responded to your email",
      "You have 5 new tasks",
      "You're now a friend with Andrew",
      "Another Notification",
      "Another One"
    ],
    title: "Welcome",
    responsive: false
  }),
  watch: {
    $route(val) {
      this.title = val.name;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
